// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h5 {
  font-size: 1rem;
  padding: 0;
  margin: 0;
}

.dayBox {
  height: 35px;
}

.dragEndcontainer ion-item {
  --min-height: 18px;
}

.dragEndcontainer {
  position: relative;
}

.monthEvent {
  --min-height: 30px;
  min-height: 30px;
}

.dragEnd {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 99999912;
  background: #838383;
  height: 100%;
  width: 1px;
  border: 1px #ff4343 solid;
}

.dragStart {
  left: 0px;
}

.startDayMark {
  background: #4aaeee;
}

.endDayMark {
  background: #2c6d8f;
}

.dragOnver {
  background: #4aaeee;
}

.yearDayBox {
  float: left;
  text-align: center;
  padding: 3px;
  width: 14%;
  height: 35px;
}

.yearDayEvents {
  line-height: 7px;
}

.dayInMonthEvents::-webkit-scrollbar {
  width: 3px;
  height: 3px;
}

.dayInMonthEvents::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
  border-radius: 1px;
}

.dayInMonthEvents::-webkit-scrollbar-thumb {
  border-radius: 1px;
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
}

.monthBox {
  clear: both;
  display: block;
  margin: 0;
}

.marked {
  border: 1px solid #0b3e6f;
}

.notfree {
  background: -webkit-linear-gradient(360deg, #B22859, #8E1339);
}

.notfreeLong {
  background: -webkit-linear-gradient(360deg, #28B259, #138E39);
}

.notfreeNext {
  background: -webkit-linear-gradient(360deg, #f8f8f8, #a8a8a8);
}

.mainImage {
  clear: both;
  height: 200px;
  display: block;
  margin: 0 auto;
}

.hours .item-md .item-button.notfree {
  font-size: 4.4rem;
  padding: 30px;
  background: -webkit-linear-gradient(360deg, #B22859, #8E1339);
}

.hours .item-md .item-button.free {
  font-size: 4.4rem;
  padding: 30px;
  background: -webkit-linear-gradient(360deg, #28B259, #138E39);
}

.hours ion-label span {
  font-size: 3rem;
}

.hours ion-label {
  font-size: 6rem;
}

.hour {
  width: 100%;
  border-radius: 3px;
  border-bottom: 1px solid #dfdfdf;
}

@media only screen and (max-width: 1050px) {
  .hour h3, .hour h4 {
    padding: 0px;
    margin: 0px;
  }
  .mainImage {
    width: auto;
    height: 50px;
  }
  .hours ion-label {
    font-size: 3rem;
  }
  .hours .item-md .item-button.free {
    font-size: 1.4rem;
  }
  h5 {
    font-size: 0.8rem;
    color: white;
  }
  h4 {
    font-size: 1rem;
    color: white;
  }
  h3 {
    font-size: 1.5rem;
  }
  h2 {
    font-size: 2rem;
    color: white;
  }
  h1 {
    font-size: 3rem;
    color: white;
  }
}
.boxes {
  background-color: white;
}

.underline {
  text-decoration: underline;
}

.dayInMonthConteiner {
  display: flex;
}

.dayInMonth {
  overflow-x: hidden;
  padding: 1px;
  flex: 1 1 0px;
  border-right: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
}

.dayInMonthYear {
  padding: 1px;
  flex: 1 1 0px;
}

.dayInMonthFlat {
  max-width: 150px;
}

.borderLeftTransition {
  transition: border-left-width 0.1s ease-in-out;
}

.onHoverChooseEvent:hover {
  background: #0b3e6f;
}

.dropEvent .dropEventSon {
  visibility: hidden;
}

.dropEvent:hover .dropEventSon {
  visibility: visible;
}

.highlightEvent {
  background: var(--ion-color-warning);
}

.timerow {
  height: 40px;
  max-height: 40px;
  min-height: 40px;
}

.timerowEvent {
  min-height: 40px;
  position: absolute;
  background: rgba(0, 0, 0, 0.2);
  z-index: 111213;
}

.dayInMonthConteiner2 > .cantChooseDate {
  background: #c5c5c5 !important;
}

.cantChooseDate {
  background: #e7e7e7 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/components/calendar/calendar.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,UAAA;EACA,SAAA;AACF;;AAEA;EAKE,YAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAKA;EACE,kBAAA;AAFF;;AAIA;EACE,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AADF;;AAGA;EACE,SAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAcA;EACE,UAAA;EACA,WAAA;AAXF;;AAcA;EACE,oDAAA;EACA,kBAAA;AAXF;;AAcA;EACE,kBAAA;EACA,oDAAA;AAXF;;AAeA;EACE,WAAA;EACA,cAAA;EACA,SAAA;AAZF;;AAgBA;EAEE,yBAAA;AAdF;;AAiBA;EACE,6DAAA;AAdF;;AAiBA;EACE,6DAAA;AAdF;;AAiBA;EACE,6DAAA;AAdF;;AAiBA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,aAAA;EACA,6DAAA;AAdF;;AAiBA;EACE,iBAAA;EACA,aAAA;EACA,6DAAA;AAdF;;AAiBA;EACE,eAAA;AAdF;;AAiBA;EACE,eAAA;AAdF;;AAoCA;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;AAjCF;;AAoCA;EAEE;IACE,YAAA;IACA,WAAA;EAlCF;EAwCA;IACE,WAAA;IACA,YAAA;EAtCF;EAyCA;IACE,eAAA;EAvCF;EA0CA;IACE,iBAAA;EAxCF;EA2CA;IACE,iBAAA;IACA,YAAA;EAzCF;EA4CA;IACE,eAAA;IACA,YAAA;EA1CF;EA6CA;IACE,iBAAA;EA3CF;EA8CA;IACE,eAAA;IACA,YAAA;EA5CF;EA+CA;IACE,eAAA;IACA,YAAA;EA7CF;AACF;AAgDA;EACE,uBAAA;AA9CF;;AAiDA;EACE,0BAAA;AA9CF;;AAiDA;EACE,aAAA;AA9CF;;AAiDA;EAEE,kBAAA;EACA,YAAA;EACA,aAAA;EAEA,+BAAA;EACA,gCAAA;AAhDF;;AAmDA;EAEE,YAAA;EACA,aAAA;AAjDF;;AA6DA;EACE,gBAAA;AA1DF;;AAkEA;EAKE,8CAAA;AA/DF;;AAkEA;EACE,mBAAA;AA/DF;;AAkEA;EACE,kBAAA;AA/DF;;AAkEA;EACE,mBAAA;AA/DF;;AAsEA;EACE,oCAAA;AAnEF;;AA+EA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AA5EF;;AA+EA;EACE,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;AA5EF;;AAgFA;EACE,8BAAA;AA7EF;;AA+EA;EACE,8BAAA;AA5EF","sourcesContent":["h5 {\n  font-size: 1rem;\n  padding: 0;\n  margin: 0;\n}\n\n.dayBox {\n  //float: left;\n  //text-align: center;\n  //padding: 3px;\n  //width: 14%;\n  height: 35px;\n}\n\n.dragEndcontainer ion-item{\n  --min-height: 18px;\n}\n.dragEndcontainer {\n  position: relative;\n}\n.monthEvent {\n  --min-height: 30px;\n  min-height: 30px;\n}\n\n.dragEnd {\n  position: absolute;\n  right: 0px;\n  top: 0px;\n  z-index: 99999912;\n  background: #838383;\n  height: 100%;\n  width: 1px;\n  border: 1px #ff4343 solid;\n}\n.dragStart {\n  left: 0px;\n}\n\n.startDayMark {\n  background: #4aaeee;\n}\n\n.endDayMark {\n  background: #2c6d8f;\n}\n\n.dragOnver {\n  background: #4aaeee;\n}\n\n.yearDayBox {\n  float: left;\n  text-align: center;\n  padding: 3px;\n  width: 14%;\n  height: 35px;\n}\n\n.yearDayEvents {\n  line-height: 7px;\n}\n\n.dayInMonthEvents {\n  //min-height: 35px;\n}\n\n.dayInMonthEvents {\n  //max-height: 35px;\n  //overflow-y: auto;\n  //line-height: 0px;\n}\n\n//scroll style\n.dayInMonthEvents::-webkit-scrollbar {\n  width: 3px;\n  height: 3px;\n}\n\n.dayInMonthEvents::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);\n  border-radius: 1px;\n}\n\n.dayInMonthEvents::-webkit-scrollbar-thumb {\n  border-radius: 1px;\n  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);\n}\n\n\n.monthBox {\n  clear: both;\n  display: block;\n  margin: 0;\n}\n\n\n.marked {\n  //background: -webkit-linear-gradient(360deg, #B22859, #8E1339);\n  border: 1px solid #0b3e6f;\n}\n\n.notfree {\n  background: -webkit-linear-gradient(360deg, #B22859, #8E1339);\n}\n\n.notfreeLong {\n  background: -webkit-linear-gradient(360deg, #28B259, #138E39);\n}\n\n.notfreeNext {\n  background: -webkit-linear-gradient(360deg, #f8f8f8, #a8a8a8);\n}\n\n.mainImage {\n  clear: both;\n  height: 200px;\n  display: block;\n  margin: 0 auto;\n}\n\n.hours .item-md .item-button.notfree {\n  font-size: 4.4rem;\n  padding: 30px;\n  background: -webkit-linear-gradient(360deg, #B22859, #8E1339);\n}\n\n.hours .item-md .item-button.free {\n  font-size: 4.4rem;\n  padding: 30px;\n  background: -webkit-linear-gradient(360deg, #28B259, #138E39);\n}\n\n.hours ion-label span {\n  font-size: 3rem;\n}\n\n.hours ion-label {\n  font-size: 6rem;\n}\n\n//h4 {\n//  font-size: 2rem;\n//  color: white;\n//}\n//\n//h3 {\n//  font-size: 3rem;\n//}\n//\n//h2 {\n//  font-size: 4rem;\n//  color: white;\n//}\n//\n//h1 {\n//  font-size: 5rem;\n//  color: white;\n//}\n\n.hour {\n  width: 100%;\n  border-radius: 3px;\n  border-bottom: 1px solid #dfdfdf;\n}\n\n@media only screen and (max-width: 1050px) {\n\n  .hour h3, .hour h4 {\n    padding: 0px;\n    margin: 0px;\n  }\n  .hour {\n    //min-height: 35px;\n  }\n\n  .mainImage {\n    width: auto;\n    height: 50px;\n  }\n\n  .hours ion-label {\n    font-size: 3rem;\n  }\n\n  .hours .item-md .item-button.free {\n    font-size: 1.4rem;\n  }\n\n  h5 {\n    font-size: 0.8rem;\n    color: white;\n  }\n\n  h4 {\n    font-size: 1rem;\n    color: white;\n  }\n\n  h3 {\n    font-size: 1.5rem;\n  }\n\n  h2 {\n    font-size: 2rem;\n    color: white;\n  }\n\n  h1 {\n    font-size: 3rem;\n    color: white;\n  }\n}\n\n.boxes {\n  background-color: white;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.dayInMonthConteiner {\n  display: flex;\n}\n\n.dayInMonth {\n  //margin: 8px;\n  overflow-x: hidden;\n  padding: 1px;\n  flex: 1 1 0px;\n  //max-height: 140px;\n  border-right: 1px solid #eaeaea;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.dayInMonthYear {\n  //margin: 8px;\n  padding: 1px;\n  flex: 1 1 0px;\n  //max-height: 140px;\n  //border-right: 1px solid #eaeaea;\n  //border-bottom: 1px solid #eaeaea;\n}\n\n\n.dayInMonthNotFlat {\n  //width: 14.28%;\n  //float: left;\n}\n\n.dayInMonthFlat {\n  max-width: 150px;\n}\n\n\n.borderLeftTransition:hover {\n  //border-left-width: 10px solid;\n}\n\n.borderLeftTransition {\n  -webkit-transition: border-left-width 0.1s ease-in-out;\n  -moz-transition: border-left-width 0.1s ease-in-out;\n  -ms-transition: border-left-width 0.1s ease-in-out;\n  -o-transition: border-left-width 0.1s ease-in-out;\n  transition: border-left-width 0.1s ease-in-out;\n}\n\n.onHoverChooseEvent:hover {\n  background: #0b3e6f;\n}\n\n.dropEvent .dropEventSon {\n  visibility: hidden;\n}\n\n.dropEvent:hover .dropEventSon {\n  visibility: visible;\n}\n\n.eventTitle {\n  //line-height: 14px;\n}\n\n.highlightEvent {\n  background: var(--ion-color-warning);\n}\n\n//animation\n//.col-close-transition {\n//  -webkit-transition: opacity 5s ease-in-out;\n//  -moz-transition: opacity 5s ease-in-out;\n//  -ms-transition: opacity 5s ease-in-out;\n//  -o-transition: opacity 5s ease-in-out;\n//  transition: opacity 5s ease-in-out;\n//}\n\n.timerow {\n  height: 40px;\n  max-height: 40px;\n  min-height: 40px;\n}\n\n.timerowEvent {\n  min-height: 40px;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 111213;\n}\n\n\n.dayInMonthConteiner2 > .cantChooseDate {\n  background: #c5c5c5 !important;\n}\n.cantChooseDate {\n  background: #e7e7e7 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
